import {management} from '../../../..'

import { GetManagementRainfallInputByIdlUseCase } from "./getManagementRainfallInputById";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const getManagementRainfallInputByIdlUseCase=()=>{
  const repository=new ManagementRepository(management)

  const getManagementRainfallInputById= new GetManagementRainfallInputByIdlUseCase(repository)

  return getManagementRainfallInputById
}
